export default "../css/a9ffd35b0feafa94ac541c0b78d07e06.ttf";